module.exports = __webpack_public_path__ + "img/product_95.788f88a.svg";